import { LOCATION_CREATE } from "./index";

const initialState = {
  address: {},
  loaded: false,
  error: null
};

export default function auth(state = initialState, action = {}) {
  const { type, payload, error } = action;

  if (error) {
    return {
      ...state,
      error: payload
    };
  }

  switch (type) {
    case LOCATION_CREATE:
      return {
        ...state,
        address: payload,
        loaded: true,
        error: null
      };

    default:
      return state;
  }
}
